module.exports = __webpack_public_path__ + "img/5.d80a12d4.jpg";